import { BANNER_KEYS, LOCAL_STORAGE_KEYS } from '@/app.constants';
import { isObjEmpty } from '@/utils';
import { useEffect, useState } from 'react';

const useBannerVisibility = (bannerKey: string) => {
  const [isBannerVisible, setIsBannerVisible] = useState(false);

  useEffect(() => {
    const storedBannerData = localStorage.getItem(LOCAL_STORAGE_KEYS.BANNER_KEY);
    const localStorageBannerData = (storedBannerData && JSON.parse(storedBannerData)) || {};
    if (isObjEmpty(localStorageBannerData)) {
      const defaultVisibility: Record<string, boolean> = {};
      Object.values(BANNER_KEYS).forEach((value) => {
        defaultVisibility[value] = true;
      });
      localStorage.setItem(LOCAL_STORAGE_KEYS.BANNER_KEY, JSON.stringify(defaultVisibility));
      setIsBannerVisible(true);
    } else {
      if (bannerKey in localStorageBannerData) {
        setIsBannerVisible(localStorageBannerData[bannerKey]);
      } else {
        setIsBannerVisible(true);
      }
    }
  }, [bannerKey]);

  return [isBannerVisible, setIsBannerVisible] as const;
};

export default useBannerVisibility;
